module.exports = __webpack_public_path__ + "static/media/sy2.87b76659.svg";